// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__39pNQ","title":"AfterBackImages_title__1mu2c","images":"AfterBackImages_images__1rOIw"};